
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-detail/[subId]",
      function () {
        return require("private-next-pages/subscription-detail/[subId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-detail/[subId]"])
      });
    }
  